import global_axios from '../../funciones_globales/interaccionapi';
import { CARGAR_EMBALAJE } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_Embalaje = (embalaje) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/embalajes/' + embalaje,
			method: 'GET'
		})
		.then( response => {
			let embalajeSel = response.data;
			
			dispatch({
				type: CARGAR_EMBALAJE,
				data: embalajeSel
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar embalaje', mensaje: msgError}
			});
		});
	}
}